module.exports = __webpack_public_path__ + "img/animazione-bimbi-premium.50675cda.jpg";